{
  "title": "المرفقات",
  "add": "إضافة ملفات",
  "thisRecord": "هذا السجل",
  "rules": "ملفات PDF أو صور (JPG وPNG وWebP) أو Word أو Excel أو CSV أو نصوص، بحدٍّ أقصى {{limit}} للملف.",
  "dropHint": "أو اسحب الملفات وأفلتها هنا.",
  "dropHere": "أفلِت الملفات لإرفاقها بـ {{record}}",
  "loadFailed": "تعذّر تحميل المرفقات.",
  "retry": "إعادة المحاولة",
  "uploadedBySystem": "النظام",
  "camera": {
    "take": "التقط صورة",
    "empty": "لا توجد صور بعد. التقط صورة للعمل، أو أضف ملفًا."
  },
  "empty": {
    "none": "لا توجد مرفقات.",
    "invite": {
      "document": "أرفِق إشعارات التسليم أو العقود أو الصور.",
      "purchase": "أرفِق فاتورة المورد أو إشعار التسليم.",
      "expense": "أرفِق الإيصال أو فاتورة المورد.",
      "voucher": "أرفِق إشعار البنك أو صورة الشيك أو أي إثبات آخر.",
      "party": "أرفِق العقود أو الرخص التجارية أو صور الهويات.",
      "product": "أرفِق المواصفات الفنية أو الشهادات أو الصور.",
      "photo": "أرفِق صوراً لما وجدته."
    }
  },
  "size": {
    "bytes": "{{size}} بايت",
    "kb": "{{size}} ك.ب",
    "mb": "{{size}} م.ب"
  },
  "actions": {
    "download": "تنزيل {{name}}",
    "open": "فتح {{name}} في علامة تبويب جديدة",
    "remove": "إزالة {{name}}"
  },
  "upload": {
    "waiting": "في الانتظار · {{size}}",
    "sending": "جارٍ الرفع · {{size}}",
    "sendingPercent": "جارٍ الرفع · {{percent}}% من {{size}}",
    "progressLabel": "رفع {{name}}",
    "retry": "إعادة المحاولة",
    "cancel": "إيقاف رفع {{name}}",
    "dismiss": "إخفاء {{name}}"
  },
  "remove": {
    "title": "إزالة {{name}}؟",
    "body": "لن يبقى الملف مرفقًا بـ {{record}}. لاستعادته، ارفعه من جديد.",
    "confirm": "إزالة"
  },
  "toast": {
    "removed": "تمت إزالة {{name}}"
  },
  "announce": {
    "uploading_zero": "لا ملفات للرفع.",
    "uploading_one": "جارٍ رفع ملف واحد.",
    "uploading_two": "جارٍ رفع ملفين.",
    "uploading_few": "جارٍ رفع {{count}} ملفات.",
    "uploading_many": "جارٍ رفع {{count}} ملفًا.",
    "uploading_other": "جارٍ رفع {{count}} ملف.",
    "attached": "أُرفِق {{name}}.",
    "removed": "أُزيل {{name}}."
  },
  "errors": {
    "FILE_TOO_LARGE": "حجم الملف أكبر من {{limit}}. اضغطه أو قسّمه إلى ملفات أصغر.",
    "UNSUPPORTED_FILE_TYPE": "لا يمكن إرفاق هذا النوع من الملفات. استخدم ملف PDF أو صورة أو Word أو Excel أو CSV أو ملفًا نصيًا.",
    "contentMismatch": "محتوى الملف ليس ملف {{type}} حقيقيًا. احفظه من جديد بصيغة {{type}} أو اختر ملفًا آخر.",
    "FILE_REQUIRED": "الملف فارغ. اختره مرة أخرى.",
    "IMAGE_TOO_LARGE": "أبعاد الصورة أكبر من {{max}} × {{max}} بكسل. صغّرها ثم ارفعها من جديد.",
    "FILE_UNAVAILABLE": "هذا الملف محجوز لفحص الفيروسات ولا يمكن فتحه الآن. حاول لاحقًا أو راجع المسؤول.",
    "notFound": "لم يعد هذا الملف أو السجل موجودًا. أعد تحميل الصفحة لترى المرفقات الحالية.",
    "logoType": "يجب أن يكون الشعار صورة بصيغة PNG أو JPEG أو WebP.",
    "logoTooLarge": "حجم الشعار أكبر من {{limit}}. احفظه بحجم أصغر ثم ارفعه من جديد.",
    "signatureType": "يجب أن تكون صورة التوقيع بصيغة PNG أو JPEG أو WebP.",
    "signatureTooLarge": "حجم صورة التوقيع أكبر من {{limit}}. احفظها بحجم أصغر ثم ارفعها من جديد.",
    "stampType": "يجب أن تكون صورة الختم بصيغة PNG أو JPEG أو WebP.",
    "stampTooLarge": "حجم صورة الختم أكبر من {{limit}}. احفظها بحجم أصغر ثم ارفعها من جديد."
  },
  "pending": {
    "label": "المرفقات",
    "add": "إضافة ملفات",
    "willAttach_zero": "لن يُرفَق أي ملف عند الحفظ.",
    "willAttach_one": "سيُرفَق ملف واحد عند الحفظ.",
    "willAttach_two": "سيُرفَق ملفان عند الحفظ.",
    "willAttach_few": "ستُرفَق {{count}} ملفات عند الحفظ.",
    "willAttach_many": "سيُرفَق {{count}} ملفًا عند الحفظ.",
    "willAttach_other": "سيُرفَق {{count}} ملف عند الحفظ.",
    "summary_zero": "لا ملفات",
    "summary_one": "ملف واحد",
    "summary_two": "ملفان",
    "summary_few": "{{count}} ملفات",
    "summary_many": "{{count}} ملفًا",
    "summary_other": "{{count}} ملف",
    "remove": "عدم إرفاق {{name}}",
    "toast": {
      "title": "إرفاق الملفات",
      "sending": "جارٍ إرفاق {{current}} من {{count}} · {{percent}}%",
      "attached_zero": "لم يُرفَق أي ملف.",
      "attached_one": "أُرفِق ملف واحد.",
      "attached_two": "أُرفِق ملفان.",
      "attached_few": "أُرفِقت {{count}} ملفات.",
      "attached_many": "أُرفِق {{count}} ملفًا.",
      "attached_other": "أُرفِق {{count}} ملف.",
      "failed_zero": "أُرفِقت كل الملفات.",
      "failed_one": "تعذّر إرفاق ملف واحد: {{names}}. أضِفه من جديد من السجل.",
      "failed_two": "تعذّر إرفاق ملفين: {{names}}. أضِفهما من جديد من السجل.",
      "failed_few": "تعذّر إرفاق {{count}} ملفات: {{names}}. أضِفها من جديد من السجل.",
      "failed_many": "تعذّر إرفاق {{count}} ملفًا: {{names}}. أضِفها من جديد من السجل.",
      "failed_other": "تعذّر إرفاق {{count}} ملف: {{names}}. أضِفها من جديد من السجل."
    }
  },
  "paperclip_zero": "لا مرفقات",
  "paperclip_one": "مرفق واحد",
  "paperclip_two": "مرفقان",
  "paperclip_few": "{{count}} مرفقات",
  "paperclip_many": "{{count}} مرفقًا",
  "paperclip_other": "{{count}} مرفق",
  "logo": {
    "title": "شعار الشركة",
    "body": "يُطبع في رأس الفواتير وعروض الأسعار والإشعارات الدائنة وكشوف الحساب وصفحة الفاتورة المشتركة.",
    "rules": "PNG أو JPEG أو WebP، بحدٍّ أقصى {{limit}} و{{max}} × {{max}} بكسل. يُطبع الشعار العريض على خلفية فاتحة بأفضل صورة.",
    "none": "لا يوجد شعار بعد. تُطبع المستندات باسم الشركة وحده.",
    "preview": "كما يُطبع",
    "upload": "رفع الشعار",
    "replace": "استبدال الشعار",
    "remove": "إزالة الشعار",
    "uploading": "جارٍ رفع الشعار",
    "removeTitle": "إزالة شعار الشركة؟",
    "removeBody": "ستُطبع المستندات دون شعار إلى أن ترفع شعارًا جديدًا.",
    "toast": {
      "uploaded": "تم رفع الشعار",
      "replaced": "تم استبدال الشعار",
      "removed": "تمت إزالة الشعار"
    }
  },
  "signature": {
    "title": "التوقيع المعتمد",
    "body": "يُطبع فوق سطر التوقيع في المستندات المرحّلة، ولا يُطبع أبدًا على المسودات أو المستندات المُبطَلة.",
    "rules": "PNG أو JPEG أو WebP، بحدٍّ أقصى {{limit}} و{{max}} × {{max}} بكسل. وقّع بحبر داكن على ورق أبيض ثم امسحه ضوئيًا؛ صورة PNG بخلفية شفافة تُطبع بأفضل صورة.",
    "none": "لا يوجد توقيع بعد. تُطبع المستندات المرحّلة بخانة توقيع فارغة.",
    "preview": "كما يُطبع",
    "upload": "رفع التوقيع",
    "replace": "استبدال التوقيع",
    "remove": "إزالة التوقيع",
    "uploading": "جارٍ رفع التوقيع",
    "removeTitle": "إزالة التوقيع المعتمد؟",
    "removeBody": "ستُطبع المستندات المرحّلة بخانة توقيع فارغة إلى أن ترفع توقيعًا جديدًا.",
    "toast": {
      "uploaded": "تم رفع التوقيع",
      "replaced": "تم استبدال التوقيع",
      "removed": "تمت إزالة التوقيع"
    }
  },
  "stamp": {
    "title": "ختم الشركة",
    "body": "يُطبع في خانة الختم في المستندات المرحّلة، ولا يُطبع أبدًا على المسودات أو المستندات المُبطَلة.",
    "rules": "PNG أو JPEG أو WebP، بحدٍّ أقصى {{limit}} و{{max}} × {{max}} بكسل. اختم على ورق أبيض ثم امسحه ضوئيًا وقصّ الصورة عند حافة الختم.",
    "none": "لا يوجد ختم بعد. تُطبع المستندات المرحّلة بخانة ختم فارغة.",
    "preview": "كما يُطبع",
    "upload": "رفع الختم",
    "replace": "استبدال الختم",
    "remove": "إزالة الختم",
    "uploading": "جارٍ رفع الختم",
    "removeTitle": "إزالة ختم الشركة؟",
    "removeBody": "ستُطبع المستندات المرحّلة بخانة ختم فارغة إلى أن ترفع ختمًا جديدًا.",
    "toast": {
      "uploaded": "تم رفع الختم",
      "replaced": "تم استبدال الختم",
      "removed": "تمت إزالة الختم"
    }
  }
}
